import { RouteRecordRaw } from 'vue-router';
import { Layout, ParentLayout } from '@/router/constant';
import {
  OptionsOutline,
  PersonOutline,
  PeopleOutline,
  KeyOutline,
  LocationOutline,
} from '@vicons/ionicons5';
import {
  ContactsOutlined,
  ProjectOutlined,
  SecurityScanOutlined,
  UnorderedListOutlined,
  UserSwitchOutlined,
  ShopOutlined,
  GroupOutlined,
  ControlOutlined,
} from '@vicons/antd';
import { renderIcon } from '@/utils';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/system',
    name: 'system',
    component: Layout,
    redirect: '/system/admin',
    meta: {
      title: 'System',
      icon: renderIcon(OptionsOutline),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: [
        'system_config_read',
        'system_admin_user_read',
        'system_admin_role_read',
        'system_admin_permission_read',
        'system_list_project_read',
        'system_list_site_read',
        'system_list_site_contact_read',
        'system_list_ownership_read',
        'system_list_vendor_read',
        'system_list_lookup_table_read',
      ],
      sort: 8,
    },
    children: [
      // {
      //   path: 'config',
      //   name: 'system_config',
      //   redirect: '/system/config',
      //   component: Layout,
      //   meta: {
      //     title: 'Config',
      //     icon: renderIcon(ControlOutlined),
      //     //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      //     permissions: ['system_config_read'],
      //     component: () => import('@/views/system/config/index.vue'),
      //   },
      // },
      {
        path: 'admin',
        name: 'system_admin',
        redirect: '/system/admin/user',
        component: ParentLayout,
        meta: {
          title: 'Admin',
          icon: renderIcon(SecurityScanOutlined),
          //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
          permissions: [
            'system',
            'system_admin',
            'system_admin_user',
            'system_admin_role',
            'system_admin_permission',
          ],
        },
        children: [
          {
            path: 'user',
            name: 'system_admin_user',
            meta: {
              title: 'User',
              icon: renderIcon(PersonOutline),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_admin_user'],
            },
            component: () => import('@/views/system/admin/user/index.vue'),
          },
          {
            path: 'role',
            name: 'system_admin_role',
            meta: {
              title: 'Role',
              icon: renderIcon(PeopleOutline),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_admin_role'],
            },
            component: () => import('@/views/system/admin/role/index.vue'),
          },
          {
            path: 'permission',
            name: 'system_admin_permission',
            meta: {
              title: 'Permission',
              icon: renderIcon(KeyOutline),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_admin_permission'],
            },
            component: () => import('@/views/system/admin/permission/index.vue'),
          },
        ],
      },
      {
        path: 'list',
        name: 'system_list',
        redirect: '/system/list/project',
        component: ParentLayout,
        meta: {
          title: 'List',
          icon: renderIcon(UnorderedListOutlined),
          //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
          permissions: [
            'system_list_project_read',
            'system_list_site_read',
            'system_list_site_contact_read',
            'system_list_ownership_read',
            'system_list_vendor_read',
            'system_list_lookup_table_read',
          ],
        },
        children: [
          {
            path: 'project',
            name: 'system_list_project',
            meta: {
              title: 'Project',
              icon: renderIcon(ProjectOutlined),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_project_read'],
            },
            component: () => import('@/views/system/list/project/index.vue'),
          },
          {
            path: 'site',
            name: 'system_list_site',
            meta: {
              title: 'Site',
              icon: renderIcon(LocationOutline),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_site_read'],
            },
            component: () => import('@/views/system/list/site/index.vue'),
          },
          {
            path: 'site-contact',
            name: 'system_list_site_contact',
            meta: {
              title: 'Site Contact',
              icon: renderIcon(ContactsOutlined),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_site_contact_read'],
            },
            component: () => import('@/views/system/list/site-contact/index.vue'),
          },
          {
            path: 'ownership',
            name: 'system_list_ownership',
            meta: {
              title: 'Ownership',
              icon: renderIcon(UserSwitchOutlined),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_ownership_read'],
            },
            component: () => import('@/views/system/list/ownership/index.vue'),
          },
          {
            path: 'vendor',
            name: 'system_list_vendor',
            meta: {
              title: 'Vendor',
              icon: renderIcon(ShopOutlined),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_vendor_read'],
            },
            component: () => import('@/views/system/list/vendor/index.vue'),
          },
          {
            path: 'tender-package',
            name: 'system_list_tender_package',
            meta: {
              title: 'Tender Package',
              icon: renderIcon(ShopOutlined),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_vendor_read'],
            },
            component: () => import('@/views/system/list/tender-package/index.vue'),
          },
          {
            path: 'lookup-table',
            name: 'system_list_lookup_table',
            meta: {
              title: 'Lookup Table',
              icon: renderIcon(GroupOutlined),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_lookup_table_read'],
            },
            component: () => import('@/views/system/list/lookup-table/index.vue'),
          },
          {
            path: 'delivery_instruction_template',
            name: 'system_list_delivery_instruction_template',
            meta: {
              title: 'Delivery Instruction Template',
              icon: renderIcon(UserSwitchOutlined),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['system_list_delivery_instruction_template_read'],
            },
            component: () => import('@/views/system/list/deliveryTemplate/index.vue'),
          },
        ],
      },
    ],
  },
];

export default routes;
